import { createSlice } from "@reduxjs/toolkit";
import { postFcmToken, getAllNotification, readNotification, delFcmToken, languageSelect, getAdminPrivilege } from "./notificationThunk";

const initialState = {
  fcmTokenSuccess: null,
  fcmTokenErr: null,
  allNotificationSuccess: null,
  allNotificationErr: null,
  readNotificationSuccess: null,
  readNotificationErr: null,
  delFcmTokenSuccess: null,
  delFcmTokenErr: null,
  languageSelectSuccess: null,
  languageSelectErr: null,
  getAdminPrivilegeSuccess : null,
  getAdminPrivilegeErr: null,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    resetFcmToken(state) {
      state.fcmTokenSuccess = null;
      state.fcmTokenErr = null;
    },
    resetGetAllNotification(state) {
      state.allNotificationSuccess = null;
      state.allNotificationErr = null;
    },
    resetReadNotification(state) {
      state.readNotificationSuccess = null;
      state.readNotificationErr = null;
    },
    resetDelFcmToken(state) {
      state.delFcmTokenSuccess = null;
      state.delFcmTokenErr = null;
    },
    resetLanguageSelect(state) {
      state.languageSelectSuccess = null;
      state.languageSelectErr = null;
    },
    resetGetAdminPrivilege(state){
      state.getAdminPrivilegeErr = null
    }
  },
  extraReducers: (builder) => {
    builder
      // POST FCM TOKEN
      .addCase(postFcmToken.fulfilled, (state, action) => {
        state.fcmTokenSuccess = action.payload;
      })
      .addCase(postFcmToken.rejected, (state, action) => {
        state.fcmTokenErr = action.error.message;
      })
      // DELETE FCM TOKEN
      .addCase(delFcmToken.fulfilled, (state, action) => {
        state.delFcmTokenSuccess = action.payload;
      })
      .addCase(delFcmToken.rejected, (state, action) => {
        state.delFcmTokenErr = action.error.message;
      })
      // GET ALL NOTIFICATIONS
      .addCase(getAllNotification.fulfilled, (state, action) => {
        state.allNotificationSuccess = action.payload;
      })
      .addCase(getAllNotification.rejected, (state, action) => {
        state.allNotificationErr = action.error.message;
      })
      // READ NOTIFICATIONS
      .addCase(readNotification.fulfilled, (state, action) => {
        state.readNotificationSuccess = action.payload;
      })
      .addCase(readNotification.rejected, (state, action) => {
        state.readNotificationErr = action.error.message;
      })
      // LANGUAGE SELECT
      .addCase(languageSelect.fulfilled, (state, action) => {
        state.languageSelectSuccess = action.payload;
      })
      .addCase(languageSelect.rejected, (state, action) => {
        state.languageSelectErr = action.error.message;
      })
      // GET ADMIN PRIVILEGE
      .addCase(getAdminPrivilege.fulfilled, (state, action) => {
        state.getAdminPrivilegeSuccess = action.payload;
      })
      .addCase(getAdminPrivilege.rejected, (state, action) => {
        state.getAdminPrivilegeErr = action.error.message;
      });
  },
});

export const { resetFcmToken, resetGetAllNotification, resetReadNotification, resetDelFcmToken, resetLanguageSelect, resetGetAdminPrivilege } = notificationSlice.actions;
export default notificationSlice.reducer;
